<ng-container *ngIf="data">
  <app-image [fileid]="data.icon"></app-image>
  {{ data.name }}
</ng-container>
